import { render, staticRenderFns } from "./SerialTableButtons.vue?vue&type=template&id=62f7b3e3&"
import script from "./SerialTableButtons.vue?vue&type=script&lang=js&"
export * from "./SerialTableButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports